import { CommonModule } from '@angular/common';
import { Component, computed, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UserAdminService } from '../../shared/services/user-admin.service';
import { Subscription } from 'rxjs';
import { UserInterface } from '../../shared/models/userData';
import { requestGetUserPayload } from '../../shared/models/model';
import { EmulationService } from '../../shared/services/emulation.service';
import { OktaService } from '../../shared/services/okta.service';

@Component({
  selector: 'app-emulate-user',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './emulate-user.component.html',
  styleUrl: './emulate-user.component.scss',
})
export class EmulateUserComponent implements OnDestroy {
  userEmulated: boolean = false;
  formSubmitted: boolean = false;
  userId: string = '';
  errorMessage: string = '';
  userSubscription: Subscription = new Subscription();
  userDetails: UserInterface = {};
  emulatedUser = computed(() => this._emulationService.emulatedUser());
  constructor(
    private _userAdminService: UserAdminService,
    private _emulationService: EmulationService,
    private _okta: OktaService,
  ) {
    if (this.emulatedUser()) {
      const user = this.emulatedUser();
      if (user) {
        this.userDetails = {
          userId: user.userId,
          firstName: user.name.split(' ')[0],
          lastName: user.name.split(' ')[1],
        };
        this.userEmulated = true;
      }
    }
  }

  emulateUser(): void {
    this.formSubmitted = true;
    this.userDetails = {};
    this.errorMessage = '';
    this.userEmulated = false;
    if (this.userId !== '') {
      const payload: requestGetUserPayload = {
        requestingSystem: 'FinPro',
        userName: this.userId,
        browserName: this._okta.getBrowserName(),
      };
      this.userSubscription = this._userAdminService.getUser(payload).subscribe({
        next: (data: UserInterface) => {
          this.userDetails = data;
          if (data.response === 'User not Found') {
            this.errorMessage = 'User not found';
          } else {
            this._emulationService.startEmulation({
              userId: data.userId ?? null,
              name: data.firstName + ' ' + data.lastName,
            });
            this.userEmulated = true;
          }
        },
        //Error handling
        error: (error: string) => {
          this.errorMessage = error;
        },
      });
    } else {
      this.errorMessage = 'Please enter a valid user ID';
    }
  }

  stopEmulation(): void {
    this.userEmulated = false;
    this.userId = '';
    this.errorMessage = '';
    this._emulationService.stopEmulation();
  }
  onSearch(): void {
    if (this.userId === '') {
      this.errorMessage = 'Please enter a valid user ID';
    } else {
      this.errorMessage = '';
    }
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }
}
